import { createTheme } from '@mui/material/styles';

// Create a Material UI theme instance
const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#3182ce', // Match Chakra UI blue
    },
    secondary: {
      main: '#38b2ac', // Match Chakra UI teal
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export default muiTheme; 